import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControlLabel,
  Grid,
  Switch,
  Typography,
} from '@mui/material';
import { SECTION_VISIBILITY_KEYS } from './dailyTasksUtils';

function SectionsVisibilityPanel({
  sectionsVisible,
  onChange,
  onSave,
  saving,
  dirty,
}) {
  const values = sectionsVisible || {};

  return (
    <Box>
      <Alert severity="info" sx={{ mb: 2 }}>
        Hide or show Daily Page blocks for this IST date. App <code>GET /dailies/today</code>{' '}
        honors changes immediately (not frozen in the FE snapshot). Defaults are all on.
      </Alert>

      <Grid container spacing={1}>
        {SECTION_VISIBILITY_KEYS.map((row) => (
          <Grid item xs={12} sm={6} md={4} key={row.key}>
            <FormControlLabel
              control={
                <Switch
                  checked={values[row.key] !== false}
                  onChange={(e) => onChange({ ...values, [row.key]: e.target.checked })}
                  color="primary"
                />
              }
              label={
                <Box>
                  <Typography variant="body2" fontWeight={600}>
                    {row.label}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" display="block">
                    {row.help}
                  </Typography>
                </Box>
              }
              sx={{ alignItems: 'flex-start', m: 0, width: '100%' }}
            />
          </Grid>
        ))}
      </Grid>

      <Box display="flex" justifyContent="flex-end" mt={2}>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={saving || !dirty}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {saving ? 'Saving…' : 'Save section visibility'}
        </Button>
      </Box>
    </Box>
  );
}

export default SectionsVisibilityPanel;
